export default {"src":"/_next/static/media/Beans.4f76b5f5.svg","height":300,"width":300,"blurWidth":0,"blurHeight":0};